import React from 'react';
import { useGetConsultationQuery } from '@/core/services/consultation'; // Corrected import path
import {
    Box,
    CircularProgress,
    Typography,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';

interface MeasuresTableProps {
    consultationId: string;
}

export const MeasuresTable: React.FC<MeasuresTableProps> = ({ consultationId }) => {
    const { data: consultation, error, isLoading } = useGetConsultationQuery(consultationId);

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                <CircularProgress size={20} sx={{ mr: 2 }} />
                <Typography variant="body2">Loading measurements...</Typography>
            </Box>
        );
    }

    if (error) {
        return <Alert severity="error">Could not load measurements.</Alert>;
    }

    const measures = consultation?.biologicals;

    if (!measures || measures.length === 0) {
        return <Alert severity="info">No measurements found for this consultation.</Alert>;
    }

    return (
        <TableContainer component={Paper} sx={{ border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Label</TableCell>
                        <TableCell align="right">Value</TableCell>
                        <TableCell>Unit</TableCell>
                        <TableCell>Comment</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {measures.map((measure) => (
                        <TableRow key={measure.id}>
                            <TableCell component="th" scope="row">
                                {measure.label}
                            </TableCell>
                            <TableCell align="right">{measure.value}</TableCell>
                            <TableCell>{measure.unit}</TableCell>
                            <TableCell>{measure.comment || 'N/A'}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MeasuresTable; 